import { render, staticRenderFns } from "./CreatePolicyModal.vue?vue&type=template&id=74de2148&"
import script from "./CreatePolicyModal.vue?vue&type=script&lang=js&"
export * from "./CreatePolicyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74de2148')) {
      api.createRecord('74de2148', component.options)
    } else {
      api.reload('74de2148', component.options)
    }
    module.hot.accept("./CreatePolicyModal.vue?vue&type=template&id=74de2148&", function () {
      api.rerender('74de2148', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/policy/CreatePolicyModal.vue"
export default component.exports